"use strict";

var _interopRequireDefault = require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _defineProperty2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/taiqiu/back-end/client/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ["/login"]; // no redirect whitelist

_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasInfo, userInfo, _yield$store$dispatch, apps, accessRoutes;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _getPageTitle.default)(to.meta.title);
          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 41;
            break;
          }
          if (!(to.path === "/login")) {
            _context.next = 9;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: "/"
          });
          _nprogress.default.done();
          _context.next = 39;
          break;
        case 9:
          // determine whether the user has obtained his auth authorize through getInfo
          hasInfo = _store.default.getters.user.id;
          userInfo = _store.default.getters.user;
          if (!hasInfo) {
            _context.next = 20;
            break;
          }
          if (!(to.path !== "/register")) {
            _context.next = 17;
            break;
          }
          if (userInfo.pos_id) {
            _context.next = 17;
            break;
          }
          next({
            path: "/register"
          });
          _nprogress.default.done();
          return _context.abrupt("return");
        case 17:
          next();
          _context.next = 39;
          break;
        case 20:
          _context.prev = 20;
          _context.next = 23;
          return _store.default.dispatch("user/getState");
        case 23:
          _yield$store$dispatch = _context.sent;
          apps = _yield$store$dispatch.apps;
          _context.next = 27;
          return _store.default.dispatch("app/generateRoutes", apps);
        case 27:
          accessRoutes = _context.sent;
          // dynamically add accessible routes

          _router.default.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.next = 39;
          break;
        case 32:
          _context.prev = 32;
          _context.t0 = _context["catch"](20);
          _context.next = 36;
          return _store.default.dispatch("user/resetToken");
        case 36:
          _elementUi.Message.error(_context.t0.message || "拉取权限失败，请重新登陆");
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 39:
          _context.next = 42;
          break;
        case 41:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have auth to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 42:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[20, 32]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});